import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { IComponentOptions } from "angular";
import { WorkdayUserProvisioningService } from "../workday-user-provisioning-service";

export class SendInvitationEmailCtrl {
  checked: boolean;
  disabled: boolean;

  static $inject = ["WorkdayUserProvisioningService", "UIErrorHandlingService"];

  constructor(private workdayUserProvisioningService: WorkdayUserProvisioningService, private uiErrorHandlingService: UIErrorHandlingService) {}

  updateChecked(): void {
    this.checked = !this.checked;
    this.workdayUserProvisioningService.updateWorkdaySettings({ sendInvitationEmail: this.checked }).catch((error) => {
      this.uiErrorHandlingService.handleModal(error);
    });
  }
}

export const SendInvitationEmailComponent: IComponentOptions = {
  bindings: {
    checked: "<",
    disabled: "<",
  },
  controller: SendInvitationEmailCtrl,
  templateUrl: require("./send-invitation-email.component.jade"),
};
